import { httpRequest } from "@/lib";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type ActivityLog = {
    id: number;
    description: string;
    event: string;
    subject_type: string;
    created_at: string;
    causer?: {
        name: string;
    };
    properties?: any;
};

export type PaginatedActivityLogs = {
    items: ActivityLog[];
    data: {
        total: number;
    }
};

export function useActivityLogs(limit: number = 5) {
    const query = useQuery({
        queryKey: ["dashboard-activity-logs", limit],
        queryFn: async (): Promise<AxiosResponse<PaginatedActivityLogs>> => {
            // Assuming the endpoint accepts standard Laravel pagination parameters
            return await httpRequest.get(`/log/activity?per_page=${limit}`);
        },
        keepPreviousData: true,
    });

    return {
        logs: query.data?.data?.items || [],
        isLoading: query.isLoading,
    };
}
